// import Img from "gatsby-image"
import { navigate } from "gatsby"
import React, { useContext, useState } from "react"
// import { SliderLightbox as Lightbox } from "../../design-system/organisms/lightbox"
import { FadeInBottom } from "../../design-system/styles/animations.styles"
// import useIndustryGalleryImages from "../shared/hooks/useIndustryGalleryImages"
// import useLightboxManager from "../shared/hooks/useLightboxManager"
import { UIContext } from "../shared/layout"
import ImageTiles from "../shared/solutions.imagetile"
import { ImageTileContainer } from "./solutions.style"

const SolutionsSlides = () => {
  // const fluidImages = useIndustryGalleryImages()
  // const [isLightboxVisible, _toggleLightbox] = useLightboxManager()
  const [selectedLightbox, setSelectedLightbox] = useState("")
  const toggleLightbox = (id) => {
    setSelectedLightbox(id)
    // _toggleLightbox()
  }

  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <>
      <ImageTileContainer animation={FadeInBottom} duration="1.5s" delay="0.8s">
        <ImageTiles onClick={toggleLightbox} carousel={breakpoint === "sm"} />
      </ImageTileContainer>
      {/* 
          The lightboxes have been disabled temporarily and replaced with links to their respective industry pages.
          I've left the code to be plugged back in when new lightbox images are provided. 
      */}
      {
        // isLightboxVisible &&
        selectedLightbox === "malls" && navigate("/industries/malls/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["mall"] &&
        //     fluidImages["mall"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "offices" && navigate("/industries/offices/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["office"] &&
        //     fluidImages["office"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "stadiums" && navigate("/industries/stadiums/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["stadium"] &&
        //     fluidImages["stadium"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
      {
        // isLightboxVisible &&
        selectedLightbox === "retail" && navigate("/industries/retail/")
        // <Lightbox toggle={toggleLightbox}>
        //   {fluidImages["retail"] &&
        //     fluidImages["retail"].map((node) => (
        //       <Img key={node.id} fluid={node.childImageSharp.fluid} />
        //     ))}
        // </Lightbox>
      }
    </>
  )
}

export default SolutionsSlides
